import React from 'react';
import { PageContainer } from '@ant-design/pro-layout';
import { useQuery } from '@apollo/client';
// TODO: remove comment for pass role module
import {
  // Button,
  Descriptions,
  Typography,
} from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import ProCard from '@ant-design/pro-card';
import {
  Main,
  // Link
} from '../layout';
import { GET_ME } from '../../gql/auth';
// import PassRolesToTable from './components/PassRolesToTable';
// import PassRolesFromTable from './components/PassRolesFromTable';
import { displayFacDept } from '../../utils';

const { Text } = Typography;

const UserProfile = () => {
  const { data, loading } = useQuery(GET_ME);
  const me = data?.me;

  return (
    <Main>
      <PageContainer header={{ title: 'User Profile' }} loading={loading} ghost>
        {me && (
          <>
            <ProCard>
              <Descriptions style={{ marginBottom: -16 }} column={1}>
                <Descriptions.Item label="Name">{me.name}</Descriptions.Item>
                <Descriptions.Item label="NetID">{me.netId}</Descriptions.Item>
                <Descriptions.Item label="Email">{me.email}</Descriptions.Item>
                {me.faculty && (
                  <Descriptions.Item label="Faculty">
                    {`${me.faculty.abbreviation} - ${me.faculty.name}`}
                  </Descriptions.Item>
                )}
                {me.department && (
                  <Descriptions.Item label="Department">
                    {`${me.department.abbreviation} - ${me.department.name}`}
                  </Descriptions.Item>
                )}
                <Descriptions.Item
                  label="Roles in PMS"
                  contentStyle={{
                    flexDirection: 'column',
                  }}
                >
                  {me.roles.map(
                    ({ role: { id, name }, department, faculty }) => {
                      return (
                        <Text key={`role-${id}`}>{`${name}${displayFacDept({
                          department,
                          faculty,
                        })}`}</Text>
                      );
                    }
                  )}
                </Descriptions.Item>
              </Descriptions>
            </ProCard>
            {/*TODO: pass role module  */}
            {/* <ProCard
              title="Roles passes FROM you"
              style={{ marginTop: '32px' }}
              extra={
                <Link to="/pass-roles/add">
                  <Button type="primary" icon={<PlusOutlined />}>
                    Add
                  </Button>
                </Link>
              }
            >
              <PassRolesFromTable dataSource={me.passRolesFrom} />
            </ProCard>
            <ProCard title="Roles passes TO you" style={{ marginTop: '32px' }}>
              <PassRolesToTable dataSource={me.passRolesTo} />
            </ProCard> */}
          </>
        )}
      </PageContainer>
    </Main>
  );
};

export default UserProfile;
